export type HttpLikeError = {
  status?: number;
  statusCode?: number;
  response?: { status?: number };
};

export const getStatusCodeFromError = (error: unknown): number => {
  if (!error || typeof error !== 'object') {
    return 500;
  }
  const err = error as HttpLikeError;
  return err.statusCode ?? err.status ?? err.response?.status ?? 500;
};
